import { registerEnumType } from 'type-graphql'

export enum StatusEnum {
  Active = 'Active',
  InActive = 'InActive',
  Pending = 'Pending',
}

registerEnumType(StatusEnum, {
  name: 'StatusEnum',
  description: 'The basic status of entity',
})
